/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Range_This_WeekInputs */

const cs_calendar_range_this_week = /** @type {(inputs: Calendar_Range_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento týden`)
};

const en_calendar_range_this_week = /** @type {(inputs: Calendar_Range_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This week`)
};

/**
* | output |
* | --- |
* | "This week" |
*
* @param {Calendar_Range_This_WeekInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_range_this_week = /** @type {((inputs?: Calendar_Range_This_WeekInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Range_This_WeekInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_range_this_week(inputs)
	return cs_calendar_range_this_week(inputs)
});